
const ProgramStatus = {
  APPROVED : 'APPROVED',
  UNKNOWN: 'UNKNOWN',
  PENDING: 'PENDING',
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
}

export default ProgramStatus;
